import {graphql} from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import {
    contactUsPageIntercomLinkActioned,
    ContactUsPageEmailLinkActionedAction,
} from '@/analytics/segment'
import Button from '@/components/button'
import FeatureBlock from '@/components/feature-block'
import {LoadingDots} from '@/components/loading-dots'
import {Section} from '@/styles/grid'
import {useChatbot, openChatbot} from '@/utils/chatbot'

import type {ImageSource} from '@/types/image'

interface Props {
    title?: string
    body?: string
    ctaText?: string
    image?: ImageSource
}

export const Chat = ({title, body, ctaText, image}: Props) => {
    const {isLoading, isDisabled, isEnabled} = useChatbot()

    if (isDisabled) {
        return null
    }

    return (
        <StyledSection data-testid="chat-section">
            <VisibilityWrapper $visibility={isEnabled ? 'visible' : 'hidden'}>
                <FeatureBlock title={title} headingLevel="h2" body={body} image={image} mirrored>
                    {ctaText && (
                        <Button
                            data-testid="chatbot-open-button"
                            $variant="outline"
                            onClick={() => {
                                openChatbot()
                                contactUsPageIntercomLinkActioned({
                                    action: ContactUsPageEmailLinkActionedAction.Completed,
                                })
                            }}
                        >
                            {ctaText}
                        </Button>
                    )}
                </FeatureBlock>
            </VisibilityWrapper>

            {isLoading && <LoadingDots />}
        </StyledSection>
    )
}

const StyledSection = styled(Section)`
    position: relative;
`

interface VisibilityWrapperProps {
    $visibility: 'visible' | 'hidden'
}

const VisibilityWrapper = styled.div<VisibilityWrapperProps>`
    visibility: ${(props) => props.$visibility};
`

export const chatSliceFragment = graphql`
    fragment ChatSlice on PrismicSlicePageDataBodyChat {
        __typename
        id
        primary {
            title
            body1
            cta_text
            image {
                dimensions {
                    height
                    width
                }
                alt
                copyright
                url
                gatsbyImageData(breakpoints: $imageBreakpoints, sizes: $twoColumnsAsymmetric)
            }
        }
    }
`
